"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var skylar_resume_pdf_1 = __importDefault(require("../documents/skylar_resume.pdf"));
function Header(_a) {
    var width = _a.width;
    var _b = (0, react_1.useState)(false), navOpen = _b[0], setNavOpen = _b[1];
    var logoGenerator = function (titleArray) {
        return titleArray.map(function (char, i) { return (react_1.default.createElement("span", { key: i, className: 'header--home-char' }, char)); });
    };
    if (width && width < 750) {
        return (react_1.default.createElement("header", { className: "header--mobile" },
            react_1.default.createElement("nav", { className: 'header--nav-mobile' },
                react_1.default.createElement("a", { href: "#hero", className: 'nav--link -home -mobile' },
                    " ",
                    '<SK/>'),
                react_1.default.createElement("div", { className: 'nav--hamburger', onClick: function () { return setNavOpen(function (prevNavOpen) { return !prevNavOpen; }); } },
                    react_1.default.createElement("div", { className: navOpen ? 'hamburger-top -open' : 'hamburger-top' }),
                    react_1.default.createElement("div", { className: navOpen ? 'hamburger-mid -open' : 'hamburger-mid' }),
                    react_1.default.createElement("div", { className: navOpen ? 'hamburger-bot -open' : 'hamburger-bot' })),
                react_1.default.createElement("div", { className: navOpen ? 'nav--hamburger-menu -open' : 'nav--hamburger-menu' },
                    react_1.default.createElement("a", { href: '#about', className: 'nav--link -mobile -about' }, "About"),
                    react_1.default.createElement("a", { href: '#projects', className: 'nav--link -mobile -projects' }, "Projects"),
                    react_1.default.createElement("a", { href: '#contact', className: 'nav--link -mobile -contact' }, "Contact"),
                    react_1.default.createElement("a", { href: skylar_resume_pdf_1.default, className: 'nav--link -mobile -resume' }, "Resume")))));
    }
    else {
        return (react_1.default.createElement("header", { className: "header" },
            react_1.default.createElement("nav", { className: 'header--nav' },
                react_1.default.createElement("a", { href: "#hero", className: 'nav--link -home' }, logoGenerator(["<", "S", "K", "/", ">"])),
                react_1.default.createElement("a", { href: '#about', className: 'nav--link -about' }, "About"),
                react_1.default.createElement("a", { href: '#projects', className: 'nav--link -projects' }, "Projects"),
                react_1.default.createElement("a", { href: '#contact', className: 'nav--link -contact' }, "Contact"),
                react_1.default.createElement("a", { href: skylar_resume_pdf_1.default, className: 'nav--link -resume' }, "Resume"))));
    }
}
exports.default = Header;
